var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStair = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 22.9167V20.8333H7.27083V16.1458H11.9583V11.4583H16.6458V6.77083H21.3333V3.125H23.4167V8.85417H18.7292V13.5417H14.0417V18.2292H9.35417V22.9167H3.625Z",
    fill: "#133155"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stair.e3544ba6.svg";
export { ForwardRef as ReactComponent };